<template>
        <p class="schedule-names mb-0 text-secondary">
            {{ schedule_names }}
        </p>
</template>

<script>
export default {
    props: ['schedules_for_today'],
    computed: {
        schedule_names() {
            if(!this.schedules_for_today[0]) return;

            let names = this.schedules_for_today[0].title;

            for(let i = 1; i < this.schedules_for_today.length; i++) {
                names += ` + ${this.schedules_for_today[i].title}`
            }
            
            return names;
        }
    }
}
</script>